// extracted by mini-css-extract-plugin
export var baseButton = "_vo-0";
export var controlsArrowKeys = "_vo-1";
export var controlsResetButton = "_vo-2";
export var lightGameButton = "_vo-4 _vo-0";
export var playAgainButton = "_vo-5 _vo-0";
export var startGameButton = "_vo-3 _vo-0";